module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Light-e89c8240935b10b88ebb05e97d014437.otf";